// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import {
  DefaultReferenceItemProps,
  PlasmicReferenceItem,
} from "@/wab/client/plasmic/plasmic_kit_find_references_modal/PlasmicReferenceItem";
import { HTMLElementRefOf } from "@plasmicapp/react-web";
import * as React from "react";

interface ReferenceItemProps extends DefaultReferenceItemProps {
  onClick?: () => void;
  menu?: () => React.ReactElement;
}

function ReferenceItem_(
  { menu, ...props }: ReferenceItemProps,
  ref: HTMLElementRefOf<"div">
) {
  return (
    <PlasmicReferenceItem
      listItem={{
        menu,
      }}
      root={{ ref }}
      {...props}
    />
  );
}

const ReferenceItem = React.forwardRef(ReferenceItem_);
export default ReferenceItem;
